import * as React from 'react';

function StatusComponent(props) {

    let getStatusDisplay = (status) => {
        switch(status.toLowerCase()) {
            case 'operational':
                return <span style={{ color: '#2fcc66', fontSize: 20}}>Operational</span>;
            case 'degraded_performance':
                return <span style={{ color: '#FFC400', fontSize: 20 }}>Degraded Performance</span>;
            case 'partial_outage':
                return <span style={{ color: '#DC9300', fontSize: 20}}>Partial Outage</span>;
            case 'major_outage':
                return <span style={{ color: '#DC0000', fontSize: 20}}>Major Outage</span>;
            default:
                return <span>Unkown</span>;
        }
    }


    return (
        <div className='row' style={{
            width: '600px',
            padding: '10px',
            border: '1px solid gray',
            margin: '3px',
            borderRadius: '2px',
        }}>
            <div className='col-md-6'><span style={{ fontSize: 20}}>{ props.component.name }</span></div>
            <div className='col-md-4'>{getStatusDisplay(props.component.status)}</div>
        </div>);
}

export default StatusComponent;


// WEBPACK FOOTER //
// ./ui_src/app/components/status/StatusComponent.react.jsx